import ConsumerRefService from "@api/consumer/consumerRefService";
import {FC, useCallback} from "react";
import {toastr} from "@/utils/toastHelper";
import {useNavigate, useParams} from "react-router";
import TargetForm from "./targetForm";
import {RefTargetFormValues} from "../forms/refTargetBaseInfoBlock";

const AddRefTargetForm: FC = () => {

    const initialValues: RefTargetFormValues = {
        goalId: '',
        isActive: false
    }

    const {ref_id} = useParams<{ ref_id: string }>();
    const navigate = useNavigate();

    const onSubmit = useCallback(async (values: RefTargetFormValues) => {
        const api = new ConsumerRefService();
        const result = await api.putRefTarget(ref_id || '', {
            goalId: values.goalId,
            isActive: values.isActive
        });

        if (result.success) {
            toastr.success('Редактирование реферального бонуса', 'Цель успешно создана');
            navigate(`/consumer/refs/${ref_id}/targets/`, { replace: true });
        }
        else {
            if (result.errorCode === 'RefNotFound') {
                toastr.error('Редактирование реферального бонуса', 'Бонус не найден');
            }
            else if (result.errorCode === 'GoalNotFound') {
                toastr.error('Редактирование реферального бонуса', 'Цель не найдена');
            }
            else if (result.errorCode === 'TargetExists') {
                toastr.error('Редактирование реферального бонуса', 'Эта цель уже существует');
            }
            else {
                toastr.error('Редактирование реферального бонуса', 'Неизвестная ошибка');
            }
        }
    }, [navigate, ref_id]);

    return (
        <TargetForm
            initialValues={initialValues}
            onSubmit={onSubmit}
            editForm={false}
            title="Создание цели"
            cancelUrl={`/consumer/refs/${ref_id}/targets/`} />
    )
}

export default AddRefTargetForm;
